module.exports = __webpack_public_path__ + "static/media/pokemon.1af3e2a6.png";